import {Pipe, PipeTransform} from '@angular/core';
import {normalizeRichText} from '../shared/rich-text/rich-text.util';

/**
 * Prepares a stored rich text note for an [innerHTML] binding, undoing the extra
 * escaping older saves added so "L&amp;amp;D" reads as "L&D" rather than "L&amp;D".
 */
@Pipe({name: 'richText'})
export class RichTextPipe implements PipeTransform {
  transform(value: string): string {
    return normalizeRichText(value);
  }
}
